





























































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  $_veeValidate: { validator: "new" },
})
export default class ClubPetco extends Vue {
  private usuarios: any = [];
  private clienteSelected = "";
  private radios = "1";
  private email = "";
  private telefono = "";
  private nombre1 = "";
  private ApPaterno = "";
  private ApMaterno = "";
  private idPetco = "";
  private clubPetco = "";
  private Avanzada = "d-none";
  private Petco = "";
  private tipoBusqueda = "1";
  private results = "d-none";
  private showFormReg = "d-none";
  private showFormBusqueda = "";
  /* Formulario para registrar usuario*/
  private validRegister = false;
  private name1 = "";
  private name2 = "";
  private apPaterno = "";
  private apMaterno = "";
  private correo = "";
  private celular = "";
  private telFijo = "";
  /* SnackBar*/
  private snackbar = false;
  private text = "";
  private type = "";
  private timeout = 2000;
  private dialog = false;
  /* Email rules*/
  private emailRules = [
    (v: any) => !!v || "El correo es requerido",
    (v: any) => /.+@.+/.test(v) || "Ingresa un correo electrónico válido",
  ];
  private phoneRules = [
    (v: any) => /^[0-9]+$/.test(v) || "Ingresa un número válido",
    (v: any) => (v && v.length >= 10) || "El número debe tener 10 dígitos",
  ];

  private mensaje(texto: any, type: any) {
    this.snackbar = true;
    this.text = texto;
    this.type = type;
  }

  private reset() {
    this.email = "";
    this.telefono = "";
    this.nombre1 = "";
    this.ApPaterno = "";
    this.ApMaterno = "";
    this.idPetco = "";
    this.clubPetco = "";
    this.idPetco = "";
    this.usuarios = [];
    this.results = "d-none";
  }

  private search() {
    let array: any = {};
    this.usuarios = [];
    if (this.tipoBusqueda == "1") {
      if (this.email === "" && this.telefono === "" && this.idPetco === "") {
        this.mensaje("Debes llenar al menos un campo de búsqueda", "error");
        return;
      } else {
        array = {
          correo: this.email,
          telefono: this.telefono,
          idCliente: this.idPetco,
          pais: 'CL'
        };
      }
    } else {
      if (
        this.ApPaterno === "" &&
        this.ApMaterno === "" &&
        this.nombre1 === ""
      ) {
        this.mensaje("Debes llenar al menos un campo de búsqueda", "error");
        return;
      } else {
        array = {
          apPaterno: this.ApPaterno,
          apMaterno: this.ApMaterno,
          nombre: this.nombre1,
          pais: 'CL'
        };
      }
    }
    //Obtenemos al cliente
    this.$store.dispatch("getCliente", array).then((valor) => {
      if (Object.keys(valor.data).length === 0) {
        // No hay resultados
        this.results = "d-none";
        this.mensaje(
          "No se encontró ningún cliente con los datos proporcionados",
          "error"
        );
      } else {
        this.results = "";
        this.usuarios = valor.data;
      }
    });
  }

  // Mostrar campos para registrar cliente
  private showCamposRegistrar() {
    this.showFormReg = "";
    this.showFormBusqueda = "d-none";
    this.reset();
  }

  // Registrar a un cliente
  private validateForm() {
    // @ts-ignore
    this.$validator.validate().then((result) => {
      if (result) {
        // Formulario válido
        let array = {
          idCliente: "",
          nombre: this.name1.toUpperCase(),
          segNombre: this.name2.toUpperCase(),
          apPaterno: this.apPaterno.toUpperCase(),
          apMaterno: this.apMaterno.toUpperCase(),
          fechaNac: "",
          ciudadNac: "",
          edoCivil: "",
          genero: "",
          rfc: "",
          curp: "",
          calle: "",
          num: "",
          colonia: "",
          municipio: "",
          ciudad: "",
          codPostal: "",
          estado: "",
          telefono: this.telFijo,
          celular: this.celular,
          telTrab: "",
          extTrab: "",
          email: this.correo,
          viaContacto: "1",
          bloqueoPubli: "",
          tiendaOrigen: '',
          pais: 'CL'
        };
        // Insertamos el arreglo
        this.$store.dispatch("addCliente", array).then((valor) => {
          if (valor.replyCode === 201) {
            // Cliente insertado
            this.reset();
            this.mensaje("Cliente registrado correctamente", "success");
            this.showFormReg = "d-none";
            this.showFormBusqueda = "";
          } else {
            this.reset();
            this.mensaje(
              "Error al registrar cliente, por favor intenta más tarde",
              "error"
            );
          }
        });
      } else {
        this.mensaje("Se deben llenar todos los campos.", "error");
      }
    });
  }

  // Cambio en los radios para tipo de búsqueda
  @Watch("radios")
  private taskTime(newValue: any) {
    this.tipoBusqueda = newValue;
    this.reset();
    if (newValue == "2") {
      this.Avanzada = "";
      this.Petco = "d-none";
    } else {
      this.Petco = "";
      this.Avanzada = "d-none";
    }
  }
  private isDefined(param: any) {
    return param !== null && param !== undefined && param !== "";
  }
  // Enviamos al cliente
  private selectCliente(cliente: any) {
    if (cliente.ID_CLIENTE != "") {
      this.clienteSelected = cliente.ID_CLIENTE.substr(5); // Quitamos ceros
      this.$router.push(
        this.isDefined(this.$store.getters.idCallCenter)
          ? "/callCenter/user/" + this.clienteSelected
          : "/user/" + this.clienteSelected
      );
    }
  }
  private getArchivo() {
    this.dialog = true;
    let fecha = new Date();
    const year = fecha.getFullYear();
    const mes = fecha.getMonth();
    this.$store
      .dispatch("getReporte", [
        this.$store.getters.getIdUsuarioCallCenter,
        year,
        mes,
      ])
      .then((respuesta) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([respuesta.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "Reporte-" + year + "-" + (mes + 1) + ".xlsx"
        );
        document.body.appendChild(fileLink);

        fileLink.click();
        this.dialog = false;
      })
      .catch((error) => {
        this.dialog = false;
      });
  }
}
